import React, { useState, useEffect } from "react";

let globalToast = null;

const Toast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = "success", duration = 3000) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type, duration }]);
    
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, duration);
  };

  useEffect(() => {
    globalToast = { showToast };
    return () => {
      globalToast = null;
    };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-5 right-5 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg animate-slide-in ${
            toast.type === "success"
              ? "bg-green-50 border-l-4 border-green-500 text-green-800"
              : toast.type === "error"
              ? "bg-red-50 border-l-4 border-red-500 text-red-800"
              : toast.type === "warning"
              ? "bg-yellow-50 border-l-4 border-yellow-500 text-yellow-800"
              : "bg-blue-50 border-l-4 border-blue-500 text-blue-800"
          }`}
        >
          <span className="material-symbols-outlined text-[20px]">
            {toast.type === "success"
              ? "check_circle"
              : toast.type === "error"
              ? "error"
              : toast.type === "warning"
              ? "warning"
              : "info"}
          </span>
          <span className="text-sm font-medium">{toast.message}</span>
          <button
            onClick={() => {
              setToasts((prev) => prev.filter((t) => t.id !== toast.id));
            }}
            className="ml-2 text-gray-400 hover:text-gray-600"
          >
            <span className="material-symbols-outlined text-[16px]">close</span>
          </button>
        </div>
      ))}
    </div>
  );
};

// Helper function to show toast from anywhere
export const showToast = (message, type = "success", duration = 3000) => {
  if (globalToast) {
    globalToast.showToast(message, type, duration);
  } else {
    console.warn("Toast not mounted yet");
  }
};

export default Toast;